module.exports = __webpack_public_path__ + "fonts/iranyekanweblightfanum.b29cf05.woff";